import { isAxiosError } from 'axios';
import { message } from 'antd';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleApiServiceError = (err: any) => {
  if (isAxiosError(err)) {
    const BannerMessage = `Error: ${String(err.response?.data) || 'Unknown error'}`;
    message.warning(BannerMessage, 4);
  } else {
    message.warning('Error', 1);
  }
};

export default handleApiServiceError;
